import { AxiosRequestConfig } from 'axios'
import { apiService } from '../../api-base'
import {
  BlogPostActionResponse,
  BlogPostResponse,
  BlogPostsResponse,
  CreateBlogPostPayload,
} from './types'

export class BlogPostsService {
  static getPosts(config?: AxiosRequestConfig) {
    return apiService.get<BlogPostsResponse>('/posts', config)
  }

  static getPostById(id: string, config?: AxiosRequestConfig) {
    return apiService.get<BlogPostResponse>(`/posts/${id}`, config)
  }

  static createPost(data: CreateBlogPostPayload) {
    return apiService.post<BlogPostResponse>('/posts', data)
  }

  static updatePost(id: string, data: CreateBlogPostPayload) {
    return apiService.put<BlogPostResponse>(`/posts/${id}`, data)
  }

  static deletePost(id: string) {
    return apiService.delete<BlogPostActionResponse>(`/posts/${id}`)
  }
}
